<template lang="pug">
  .container.grid-lg
    page-title(title="Assinaturas com meu link" icon="fas fa-dollar-sign" subtitle="São as assinaturas que utilizaram o seu link e te rendem dinheiro")
      div(slot="actions")
        router-link.btn.btn-link.tooltip.tooltip-left.mr-2(
          :to="{ name: 'filiationSubscriptions.list.filter', query: $route.query }"
          data-tooltip="Filtrar"
        )
          i.fas.fa-filter
          span.badge(v-if="Boolean($route.query.q)")
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      .table-responsive(v-if="list && list.rows.length > 0")
        table.table.table-responsive.table-hover.table-striped
          thead
            tr
              th Hora da assinatura
              th.text-right Valor da assinatura
              th.text-right Percentual ganho
              th.text-right Valor ganho
              th.text-right Ações
          tbody
            tr(v-for="row in list.rows")
              td
                | {{ row.subscription.createdAt | date('DD/MM/YYYY HH:mm') }}
                small(v-if="row.subscription.discountIntegrationPlan")  (com desconto)
              td.text-right
                span(v-if="row.subscription.discountIntegrationPlan") {{ row.subscription.discountIntegrationPlan.valueWithDiscount | currency('R$ ') }}
                span(v-else) {{ row.subscription.plan.price | currency('R$ ') }}
              td.text-right {{ row.percentage | currency('', ' %') }}
              td.text-right
                .text-bold.text-success {{ row.amount | currency('R$ ') }}
              td.text-right
                router-link.btn.btn-sm.btn-action.btn-primary.tooltip.tooltip-left(
                  data-tooltip="Exibir"
                  :to="{ name: 'filiationSubscriptions.show', params: { id: row.id } }"
                )
                  i.fas.fa-eye
    router-view
</template>

<script>
import listMixin from '@/mixins/list'
import filiationSubscription from '@/services/api/filiationSubscriptions'

export default {
  mixins: [listMixin],
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await filiationSubscription.list(params)
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
